import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "settings__title" }
const _hoisted_3 = {
  key: 0,
  class: "settings__single"
}
const _hoisted_4 = { class: "settings__block-title" }
const _hoisted_5 = { class: "settings__container" }
const _hoisted_6 = { class: "settings__block" }
const _hoisted_7 = {
  class: "settings__label d-flex gap-sm align-items-center",
  style: {"max-width":"none"}
}
const _hoisted_8 = { style: {"font-family":"monospace","word-break":"break-word"} }
const _hoisted_9 = { class: "settings__single" }
const _hoisted_10 = { class: "settings__block-title" }
const _hoisted_11 = { class: "settings__container" }
const _hoisted_12 = { class: "settings__block" }
const _hoisted_13 = { class: "settings__label" }
const _hoisted_14 = { class: "settings__content settings__content" }
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = { class: "tfa-status text-capitalize-first" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { class: "settings__block" }
const _hoisted_20 = { class: "settings__label text-capitalize-first" }
const _hoisted_21 = { class: "settings__content" }
const _hoisted_22 = { class: "settings__block" }
const _hoisted_23 = { class: "settings__label text-capitalize-first" }
const _hoisted_24 = { class: "settings__content" }
const _hoisted_25 = { class: "settings__block" }
const _hoisted_26 = { class: "settings__content" }
const _hoisted_27 = { class: "text-capitalize-first" }
const _hoisted_28 = {
  key: 1,
  class: "settings__single"
}
const _hoisted_29 = { class: "settings__block-title" }
const _hoisted_30 = { class: "settings__container" }
const _hoisted_31 = { class: "settings__block" }
const _hoisted_32 = { class: "settings__label" }
const _hoisted_33 = { class: "settings__content" }
const _hoisted_34 = { class: "user-nickname" }
const _hoisted_35 = ["src"]
const _hoisted_36 = ["href"]
const _hoisted_37 = {
  ref: "tgBotNotificationsLink",
  href: "",
  target: "_blank",
  style: {"display":"none"}
}
const _hoisted_38 = { class: "settings__block" }
const _hoisted_39 = { class: "settings__label settings__label--start" }
const _hoisted_40 = { class: "settings__content" }
const _hoisted_41 = { class: "checkbox__list" }
const _hoisted_42 = { class: "checkbox" }
const _hoisted_43 = ["value", "id", "disabled"]
const _hoisted_44 = ["for"]
const _hoisted_45 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_46 = { class: "settings__block" }
const _hoisted_47 = { class: "settings__content" }
const _hoisted_48 = { class: "text-capitalize-first" }
const _hoisted_49 = { class: "settings__block-title" }
const _hoisted_50 = { class: "settings__container" }
const _hoisted_51 = { class: "settings__block" }
const _hoisted_52 = { class: "settings__label text-capitalize-first" }
const _hoisted_53 = { class: "settings__content" }
const _hoisted_54 = { class: "switch" }
const _hoisted_55 = { class: "settings__block" }
const _hoisted_56 = { class: "settings__label settings__label--start text-capitalize-first" }
const _hoisted_57 = { class: "settings__content" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "text-muted small" }
const _hoisted_60 = { class: "settings__block" }
const _hoisted_61 = { class: "settings__content" }
const _hoisted_62 = { class: "text-capitalize-first" }
const _hoisted_63 = { class: "settings__single" }
const _hoisted_64 = { class: "settings__block-title" }
const _hoisted_65 = { class: "settings__container" }
const _hoisted_66 = { class: "settings__block" }
const _hoisted_67 = { class: "settings__label" }
const _hoisted_68 = { class: "settings__content" }
const _hoisted_69 = { class: "settings__block" }
const _hoisted_70 = { class: "settings__label" }
const _hoisted_71 = { class: "settings__content" }
const _hoisted_72 = { class: "settings__block" }
const _hoisted_73 = { class: "settings__content" }
const _hoisted_74 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TwoFAInstallPopup = _resolveComponent("TwoFAInstallPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('labels.settings')), 1),
      (_ctx.isMerchant)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('labels.secret_key')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.user?.secret), 1),
                  _cache[8] || (_cache[8] = _createTextVNode()),
                  _createVNode(_component_CopyButton, {
                    value: _ctx.user?.secret
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('labels.safety')), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('labels.2fa')), 1),
            _createElementVNode("div", _hoisted_14, [
              (!_ctx.user?.is2faEnabled)
                ? (_openBlock(), _createBlock(_component_LoaderButton, {
                    key: 0,
                    "on-click": _ctx.enable2fa,
                    class: "btn btn--attention settings__btn"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('labels.enable')), 1)
                    ]),
                    _: 1
                  }, 8, ["on-click"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('labels.enabled')), 1),
                    _createVNode(_component_LoaderButton, {
                      class: "btn btn--reset settings__btn",
                      "on-click": _ctx.disable2fa
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: require(`@/apps/public/assets/img/close.svg`)
                        }, null, 8, _hoisted_17),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('labels.disable')), 1)
                      ]),
                      _: 1
                    }, 8, ["on-click"])
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('labels.new_password')), 1),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('labels.confirm_password')), 1),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordConfirm) = $event))
              }, null, 512), [
                [_vModelText, _ctx.passwordConfirm]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "settings__label" }, null, -1)),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_LoaderButton, {
                "on-click": _ctx.updateProfile,
                type: "button",
                class: "btn settings__btn btn--accept"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('button.save')), 1)
                ]),
                _: 1
              }, 8, ["on-click"])
            ])
          ])
        ])
      ]),
      (_ctx.isTrader)
        ? (_openBlock(), _createElementBlock("form", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('labels.telegram')), 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('labels.telegram_bot_notifications')), 1),
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.telegramMe?.id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_34, " @" + _toDisplayString(_ctx.telegramMe?.username), 1),
                        _createVNode(_component_LoaderButton, {
                          class: "btn btn--reset settings__btn",
                          "on-click": _ctx.unlinkTgAccount
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: require(`@/apps/public/assets/img/close.svg`)
                            }, null, 8, _hoisted_35),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.telegram_unlink_account')), 1)
                          ]),
                          _: 1
                        }, 8, ["on-click"])
                      ], 64))
                    : (_ctx.telegramMe && _ctx.telegramMe?.id === null && _ctx.tgBotNotificationsUrl !== null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: _ctx.tgBotNotificationsUrl,
                          target: "_blank",
                          class: "underline"
                        }, _toDisplayString(_ctx.$t('labels.tg_click_on_link')), 9, _hoisted_36))
                      : (_ctx.telegramMe && _ctx.telegramMe?.id === null)
                        ? (_openBlock(), _createBlock(_component_LoaderButton, {
                            key: 2,
                            "on-click": _ctx.createTgInviteRequest,
                            class: "btn btn--attention settings__btn"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('labels.telegram_link_account')), 1)
                            ]),
                            _: 1
                          }, 8, ["on-click"]))
                        : _createCommentVNode("", true),
                  _createElementVNode("a", _hoisted_37, null, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('labels.telegram_bot_notifications_settings')), 1),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.TgNotification), (notification) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          value: notification,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enabledNotifications) = $event)),
                          id: notification,
                          disabled: notification === _ctx.TgNotification.NOTIFICATION_WEEKLY_REPORT && !_ctx.user?.tgChatGroupId
                        }, null, 8, _hoisted_43), [
                          [_vModelCheckbox, _ctx.enabledNotifications]
                        ]),
                        _createElementVNode("label", { for: notification }, _toDisplayString(_ctx.$t(`tg_notifications.${notification}`)), 9, _hoisted_44),
                        (notification === _ctx.TgNotification.NOTIFICATION_WEEKLY_REPORT && !_ctx.user?.tgChatGroupId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.$t('labels.weekly_report_tg_group_hint')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "settings__label" }, null, -1)),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_LoaderButton, {
                    "on-click": _ctx.saveNotifications,
                    type: "button",
                    class: "btn settings__btn btn--accept"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('button.save')), 1)
                    ]),
                    _: 1
                  }, 8, ["on-click"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTrader && _ctx.concurrentDealsLimitEnabled)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            class: "settings__single",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('labels.concurrent_deals_limit')), 1),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('labels.enabled')), 1),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isConcurrentDealsLimitEnabled) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.isConcurrentDealsLimitEnabled]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "slider" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('labels.concurrent_deals_limit_value')), 1),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_FormInputWrapper, {
                    field: "concurrentDealsLimit",
                    form: "concurrentDealsLimit"
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.concurrentDealsLimit) = $event)),
                        disabled: !_ctx.isConcurrentDealsLimitEnabled,
                        type: "number",
                        min: "1",
                        id: "concurrentDealsLimit"
                      }, null, 10, _hoisted_58), [
                        [
                          _vModelText,
                          _ctx.concurrentDealsLimit,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('labels.concurrent_deals_limit_hint')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "settings__label" }, null, -1)),
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_LoaderButton, {
                    "on-click": _ctx.saveConcurrentDealsLimit,
                    type: "button",
                    class: "btn settings__btn btn--accept"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('button.save')), 1)
                    ]),
                    _: 1
                  }, 8, ["on-click"])
                ])
              ])
            ])
          ], 32))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('labels.profile')), 1),
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('labels.timezone')), 1),
            _createElementVNode("div", _hoisted_68, [
              _createVNode(_component_Multiselect, {
                class: "",
                name: "timezone",
                id: "timezone",
                placeholder: _ctx.$t('labels.timezone'),
                options: _ctx.moment.tz.names(),
                modelValue: _ctx.timezone,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.timezone) = $event)),
                "select-label": "Select",
                "open-direction": "bottom",
                autocomplete: "timezone",
                multiple: false,
                searchable: true,
                "internal-search": true,
                "clear-on-select": false,
                "close-on-select": true,
                "options-limit": 100,
                limit: 1000,
                "show-no-results": false,
                "hide-selected": false
              }, null, 8, ["placeholder", "options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('labels.lang')), 1),
            _createElementVNode("div", _hoisted_71, [
              _createVNode(_component_Multiselect, {
                placeholder: _ctx.$t('labels.lang'),
                name: "lang",
                id: "lang",
                options: ['ru', 'en'],
                modelValue: _ctx.lang,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lang) = $event)),
                "select-label": "Select",
                "open-direction": "bottom",
                autocomplete: "lang",
                multiple: false,
                searchable: true,
                "internal-search": true,
                "clear-on-select": false,
                "close-on-select": true,
                "options-limit": 100,
                limit: 1000,
                "show-no-results": false,
                "hide-selected": false
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "settings__label" }, null, -1)),
            _createElementVNode("div", _hoisted_73, [
              _createVNode(_component_LoaderButton, {
                "on-click": _ctx.updateProfile,
                type: "button",
                class: "btn settings__btn btn--accept"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t('button.save')), 1)
                ]),
                _: 1
              }, 8, ["on-click"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_TwoFAInstallPopup, { ref: "tfaPopup" }, null, 512)
  ], 64))
}